class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.closeButton = this.querySelector('button[type="button"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.firstFocusable = null;
    this.focusableElements = [];

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.closeButton?.addEventListener('click', this.close.bind(this));
    this.resetButton?.addEventListener('click', this.reset.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (this.detailsContainer.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    setScrollbarWidth?.();
    setHeaderBottomPosition?.();

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    this.detailsContainer.setAttribute('open', true);
    document.body.classList.add('search-modal--open');
    document.body.addEventListener('click', this.onBodyClickEvent);

    this.focusableElements = this.detailsContainer.querySelectorAll(
      'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    console.log('this.focusableElements', this.focusableElements);
    this.firstFocusable = this.focusableElements[0];
    this.firstFocusable?.focus();

    this.handleTabTrap = this.trapFocus.bind(this);
    document.addEventListener('keydown', this.handleTabTrap);
  }

  close() {
    this.detailsContainer.removeAttribute('open');
    document.body.classList.remove('search-modal--open');
    document.removeEventListener('keydown', this.handleTabTrap);
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    event.preventDefault();
    this.querySelector('input[type="search"]').value = '';
  }

  trapFocus(event) {
    if (event.key !== 'Tab') return;

    const focusables = Array.from(this.focusableElements).filter(el => el.offsetParent !== null);
    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === first || !this.contains(document.activeElement)) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last || !this.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    }
  }
}

customElements.define('search-modal', SearchModal);
